import * as Yup from 'yup';

export interface OrganizationDetailsForm {
  name: string;
  logo?: File;
}

const organizationDetailsSchema = (t: (key: string) => string) =>
  Yup.object().shape({
    name: Yup.string().required(t('organization.errors.name_required')),
    logo: Yup.mixed<File>()
      .nullable()
      .optional()
      .test('fileSize', t('organization.errors.logo_size'), (value) => {
        if (!value) return true;
        return value.size <= 5000000; // 5MB
      })
      .test('fileType', t('organization.errors.logo_type'), (value) => {
        if (!value) return true;
        return ['image/jpeg', 'image/png', 'image/svg+xml'].includes(value.type);
      })
  }) as Yup.ObjectSchema<OrganizationDetailsForm>;

export default organizationDetailsSchema;
